function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\r\n.cls-1,.cls-2{isolation:isolate;font-size:190.04px;font-family:ArialRoundedMTBold, Arial Rounded MT Bold;}\r\n.cls-1,.cls-2,.cls-4{fill:#f75356;}\r\n.cls-2{letter-spacing:-0.01em;}\r\n.cls-3{fill:#f92b7f;}\r\n"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Dogs Allowed");

var _ref4 =
/*#__PURE__*/
React.createElement("text", {
  isolation: "isolate",
  fontSize: "190.04px",
  fontFamily: "ArialRoundedMTBold, Arial Rounded MT Bold",
  fill: "#f75356",
  transform: "translate(0 164.19)"
}, React.createElement("tspan", {
  xmlSpace: "preserve"
}, "D   Gs All  "));

var _ref5 =
/*#__PURE__*/
React.createElement("text", {
  isolation: "isolate",
  fontSize: "190.04px",
  fontFamily: "ArialRoundedMTBold, Arial Rounded MT Bold",
  fill: "#f75356",
  letterSpacing: "-0.01em",
  transform: "translate(918.9 164.19)"
}, "w");

var _ref6 =
/*#__PURE__*/
React.createElement("text", {
  isolation: "isolate",
  fontSize: "190.04px",
  fontFamily: "ArialRoundedMTBold, Arial Rounded MT Bold",
  fill: "#f75356",
  transform: "translate(1070.91 164.19)"
}, "ed");

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f92b7f",
  d: "M267.78,456.31",
  transform: "translate(-38.39 -262.07)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M306.74,319.67c-10.26-1.71-19.76,8-21.28,21.47s5.51,25.84,16,27.56,19.76-8,21.28-21.47S317.19,321.38,306.74,319.67Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M245.55,305c1.52,14.63,10.83,25.84,20.9,25.27s17.1-12.92,15.58-27.37-10.83-25.84-20.9-25.27S244.22,290.6,245.55,305Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M207,388.27c8.74-5.7,10.45-19.76,3.61-31.55S191.2,340,182.46,345.52s-10.45,19.76-3.61,31.55S198.23,394,207,388.27Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M198.42,320.24c4.37,13.87,15.77,22.42,25.27,19s13.68-17.48,9.12-31.55-15.77-22.42-25.27-19S193.86,306.37,198.42,320.24Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M288.88,376.49A34.18,34.18,0,0,1,275,358.63a25,25,0,0,0-28.13-15h0a25.11,25.11,0,0,0-19.76,25.08,35.26,35.26,0,0,1-5.51,21.85c-3,4.75-19.38,22.23-6.46,38.39,8.55,10.83,24.51,13.3,34,6.27,1.52-1.14,1.9-1.14,7.79-5.7a16.94,16.94,0,0,1,7.22-3.42,16.23,16.23,0,0,1,8,.19,75.74,75.74,0,0,0,9.5,2.09c11.59,2.66,25.08-6.08,28.7-19.38C315.67,389,293.63,379.53,288.88,376.49Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "#f75356",
  cx: 217.99,
  cy: 129.62,
  r: 24.7
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f92b7f",
  d: "M899.27,430.08",
  transform: "translate(-38.39 -262.07)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M949.06,366.61c-5.13-3-12.16-.19-15.77,6.65s-2.66,14.82,2.47,17.86,12.16.19,15.77-6.65S954,369.65,949.06,366.61Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M920,345.71c-2.28,8,.19,16,5.7,17.86s11.78-3,14.06-11-.19-16-5.7-17.86S922.27,337.72,920,345.71Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M881.79,381.24c5.89-1.14,9.69-8.17,8.74-15.77s-6.65-12.92-12.35-12-9.69,8.17-8.74,15.77S876.09,382.19,881.79,381.24Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M891.86,343.62c-.57,8.36,3.42,15.2,9.31,15.39s11-6.27,11.59-14.63c.76-8.17-3.42-15.2-9.31-15.39S892.62,335.25,891.86,343.62Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#f75356",
  d: "M927.4,392.64A20.31,20.31,0,0,1,924,380.29a14.08,14.08,0,0,0-11.59-13.87h0a14.25,14.25,0,0,0-15.77,8.93,19.61,19.61,0,0,1-7.6,10.26c-2.66,1.71-15,7.41-11.78,18.81,2.09,7.41,10.07,12.16,16.53,10.64,1.14-.38,1.33-.19,5.32-1.33a9.29,9.29,0,0,1,4.56-.19,8.44,8.44,0,0,1,4.18,1.9c3.42,2.47,3.61,2.47,4.56,3.23,5.51,3.8,14.44,2.28,19.19-4C938.8,405,929.3,395.31,927.4,392.64Z",
  transform: "translate(-38.39 -262.07)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "#f75356",
  cx: 907.01,
  cy: 393.74,
  r: 14.06,
  transform: "translate(161.09 822.38) rotate(-67.78)"
});

var SvgDogsAllowed = function SvgDogsAllowed(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1302.61 204.28",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDogsAllowed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DogsAllowed.f2607c5c.svg";
export { ForwardRef as ReactComponent };